import { render, staticRenderFns } from "./chapterTip.vue?vue&type=template&id=5680935c&scoped=true&"
import script from "./chapterTip.vue?vue&type=script&lang=js&"
export * from "./chapterTip.vue?vue&type=script&lang=js&"
import style0 from "./chapterTip.vue?vue&type=style&index=0&id=5680935c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5680935c",
  null
  
)

export default component.exports